
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import MemoryNumbersSupportPage from './pages/MemoryNumbersSupport/MemoryNumbersSupport';
import MemoryNumbersPrivacyPolicy from './pages/MemoryNumbersPrivacyPolicy/MemoryNumbersPrivacyPolicy';
import HomePage from './pages/Home/Home';
import EmojiCrushPrivacyPolicy from "./pages/EmojiCrushPrivacyPolicy copy/MemoryNumbersPrivacyPolicy";
import EmojiCrushSupport from "./pages/EmojiCrushSupport/EmojiCrushSupport";

export const pages = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/recall-numbers-privacy-policy",
    element: <MemoryNumbersPrivacyPolicy />,
  },
  {
    path: "/recall-numbers-support",
    element: <MemoryNumbersSupportPage />,
  },
  {
    path: "/emoji-crush-privacy-policy",
    element: <EmojiCrushPrivacyPolicy />,
  },
  {
    path: "/emoji-crush-support",
    element: <EmojiCrushSupport />,
  },
];

export const router = createBrowserRouter(pages);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
